import React from 'react';

class Compatibility extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <React.Fragment>
                <div id='compatibility' className='compatibility-container'>
                    <div className="container ptb-100 d-flex flex-column align-items-center">
                        <div>
                            <h2 className="mb-5">App Compatibility</h2>
                        </div>
                        <div className="container justify-content-center">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/mrx-x10.png" alt="mrx-x10"></img>
                                    <p>MRX x10 (310, 510, 710)</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/mrx-x20.png" alt="mrx-x20"></img>
                                    <p>MRX x20 (520, 720, 1120)</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/mrx-x40.png" alt="mrx-x40"></img>
                                    <p>MRX x40 (540, 740, 1140)</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/str-integrated.png" alt="str-integrated"></img>
                                    <p>STR Integrated Amplifier</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/avm-60.png" alt="avm-60"></img>
                                    <p>AVM60</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/avm-90.png" alt="avm-90"></img>
                                    <p>AVM70 and AVM90</p>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <img src="img/str-preamp-resized.png" alt="str-preamp"></img>
                                    <p>STR Preamplifier</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Compatibility;